/**
 * Key-Parser für Feldnamen mit Index-Notation
 * Beispiel: "Tiefe[0]" -> { key: "Tiefe", index: 0 }
 */

export interface KeyData {
	key: string;
	index?: number;
	suffix?: string;
}

/**
 * Parst einen Feldnamen und extrahiert Key, Index und Suffix
 * @param key Feldname, z.B. "Tiefe[0]" oder "SMächtigkeit"
 * @returns Geparste Daten
 */
export function kd(key: string): KeyData {
	if (!key) {
		console.warn('kd: Empty key provided');
		return { key: '' };
	}
	const m = key.match(/([^\[^\]]*)(\[[0-9]*\])?([^\[^\]]*)?/);
	if (m) {
		return {
			key: m[1],
			index: m[2] ? parseInt(m[2].substring(1, m[2].length - 1)) : undefined,
			suffix: m[3]
		};
	}
	return { key: key };
}

/**
 * Erstellt einen Display-String aus einem Feldnamen
 * @param key Feldname
 * @returns Anzeige-String
 */
export function displayString(key: string): string {
	const d = kd(key);
	const result = d.key + (d.suffix ? `${d.suffix}` : (d.index !== undefined ? `${d.index + 1}` : ""));
	return result;
}
